export default {
    jqueryHelpers(){
        $(".tooltipped").tooltip();

        function charactersRemaining(el){
            var parent = el.parents(".character-count");
            var count = el.val().length;
            var max = parent.attr("data-max");
            var remaining = max - count;
            parent.find(".count").text(remaining);
        }
    
        $(".character-count textarea, .character-count input").on("input", function() {
            charactersRemaining($(this));
        });
    
        $(".character-count").each(function(){
            if ($(this).find("textarea").length){
                charactersRemaining($(this).find("textarea"));
            } 
            if ($(this).find("input").length) {
                charactersRemaining($(this).find("input"));
            } 
        });

        $('.tabs').tabs();

        setTimeout(
            function () {
                if ($('.innovation-tags').length) {
                    let tags = [];
                    let s_tags = [];

                    if ($('#dashboard--innovation-library').length || $('#dashboard--innovation-library-single').length) {
                        if ($('.chips-initial').attr('data-existing-tags')) {
                            let existingTags = $('.chips-initial').attr('data-existing-tags');
                            $.each(JSON.parse(existingTags), function (key, tag) {
                                tags.push({"tag": tag.word});
                            });
                        }

                        $(".chips-initial").material_chip({
                            placeholder: 'Enter a keyword',
                            data: tags
                        });

                        if ($('.s-chips-initial').attr('data-existing-tags')) {
                            let s_existingTags = $('.s-chips-initial').attr('data-existing-tags');
                            $.each(JSON.parse(s_existingTags), function (key, tag) {
                                s_tags.push({"tag": tag.word});
                            });
                        }

                        $(".s-chips-initial").material_chip({
                            placeholder: 'Enter a keyword',
                            data: s_tags
                        });
                    } else {
                        if ($('.chips-initial').attr('data-existing-tags')) {
                            let existingTags = $('.chips-initial').attr('data-existing-tags');
                            $.each(JSON.parse(existingTags), function (key, tag) {
                                tags.push({"tag": tag.name});
                            });
                        }

                        $(".chips-initial").material_chip({
                            placeholder: 'Enter a tag',
                            data: tags
                        });
                    }

                    $(".chips-initial").on("chip.add", function (e, chip) {
                        $('.tag-data').attr('value', JSON.stringify($('.chips-initial').material_chip('data')));
                    });

                    $(".chips-initial").on("chip.delete", function (e, chip) {
                        $('.tag-data').attr('value', JSON.stringify($('.chips-initial').material_chip('data')));
                    });

                    $(".s-chips-initial").on("chip.add", function (e, chip) {
                        $('.s-tag-data').attr('value', JSON.stringify($('.s-chips-initial').material_chip('data')));
                    });

                    $(".s-chips-initial").on("chip.delete", function (e, chip) {
                        $('.s-tag-data').attr('value', JSON.stringify($('.s-chips-initial').material_chip('data')));
                    });
                }
            }, 1000);
    }
}